import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { CheckCircle2, Landmark } from "lucide-react";

export function StripeConnectCard() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/payments/connect/status").then((r) => setS(r.data)).catch(() => setS({ connected: false })); }, []);
  const connect = async () => {
    setBusy(true);
    try { const { data } = await api.post("/payments/connect/onboard", { origin_url: window.location.origin }); window.location.href = data.url; }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); setBusy(false); }
  };
  if (!s) return null;
  return (
    <div className="bg-white rounded-2xl border border-stone-200 p-6 shadow-sm" data-testid="stripe-connect-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-xl bg-[#635BFF]/10 flex items-center justify-center text-[#635BFF]"><Landmark className="h-5 w-5" /></div>
          <div><h2 className="font-semibold text-lg leading-tight">Get paid by clients</h2><p className="text-sm text-stone-500">Deposits, no-show fees, vouchers & courses go straight to your bank</p></div>
        </div>
        <span data-testid="stripe-connect-status" className={`text-xs font-medium px-3 py-1 rounded-full ${s.connected ? "bg-emerald-50 text-emerald-700" : "bg-amber-50 text-amber-700"}`}>{s.connected ? "Connected" : s.started ? "Setup not finished" : "Not connected"}</span>
      </div>
      {s.connected ? (
        <p className="mt-4 text-sm text-stone-600 flex items-center gap-2"><CheckCircle2 className="h-4 w-4 text-emerald-600" />Client payments are paid into your own Stripe account{s.payouts_enabled ? " and out to your bank" : ""}. You keep 100% (Stripe's card fee applies).</p>
      ) : (
        <div className="mt-4 text-sm text-stone-600 space-y-3">
          <p>Connect a Stripe account to take online deposits and sell vouchers and courses. It takes about 5 minutes. You'll need your bank details and ID. <b>Until you connect, online bookings don't take a deposit.</b></p>
          <Button data-testid="stripe-connect-button" disabled={busy} onClick={connect} className="rounded-full bg-[#635BFF] hover:bg-[#5249e0]">{busy ? "Opening Stripe…" : s.started ? "Finish setting up payments" : "Connect payments"}</Button>
        </div>
      )}
    </div>
  );
}
